import { useState, useEffect } from 'react';
import { authAPI } from '../api';
import { useAuth } from '../context/AuthContext';

export default function WhatsAppButton() {
  const { user, loading } = useAuth();
  const [num, setNum] = useState((process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, ''));

  useEffect(() => {
    if (loading || !user) {
      return;
    }

    authAPI.publicSettings().then(r => {
      const whatsappNum = (r.data.settings?.whatsapp_number || process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, '');
      setNum(whatsappNum);
    }).catch(() => {
      setNum((process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, ''));
    });
  }, [loading, user]);

  if (loading || !user) {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${num}?text=Hello%20NiceBooster%20Support%2C%20I%20need%20help%20with%20my%20order.`}
      target="_blank"
      rel="noreferrer"
      title="Chat with support on WhatsApp"
      style={{
        position: 'fixed', bottom: 28, right: 28,
        width: 56, height: 56, borderRadius: '50%',
        background: '#25D366',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 26, boxShadow: '0 4px 24px rgba(37,211,102,0.45)',
        textDecoration: 'none', zIndex: 999,
        transition: 'transform 0.2s, box-shadow 0.2s',
        animation: 'waPulse 2.5s infinite',
        color: 'white'
      }}
      onMouseOver={e => { e.currentTarget.style.transform = 'scale(1.12)'; e.currentTarget.style.boxShadow = '0 6px 32px rgba(37,211,102,0.65)'; }}
      onMouseOut={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(37,211,102,0.45)'; }}
    >
      <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.031 0C5.396 0 .029 5.367.029 11.987c0 2.108.549 4.168 1.595 5.97L.005 24l6.19-1.622a11.94 11.94 0 0 0 5.836 1.509h.005c6.632 0 12-5.367 12-11.987C24.036 5.368 18.665 0 12.031 0zm-.005 21.903a9.96 9.96 0 0 1-5.076-1.39l-.364-.216-3.771.989 1.006-3.676-.237-.377a9.914 9.914 0 0 1-1.52-5.246c0-5.502 4.48-9.982 9.987-9.982 2.666 0 5.172 1.038 7.058 2.925a9.928 9.928 0 0 1 2.921 7.062c-.005 5.503-4.485 9.986-9.994 9.986zm5.474-7.481c-.3-.15-1.776-.876-2.052-.976-.275-.101-.476-.15-.676.15s-.777.976-.952 1.176-.351.226-.652.075a8.215 8.215 0 0 1-2.417-1.493 9.07 9.07 0 0 1-1.674-2.083c-.176-.301-.019-.464.132-.614.135-.135.301-.351.451-.527.151-.176.201-.301.301-.502.101-.201.05-.376-.025-.526-.075-.151-.676-1.63-.927-2.232-.244-.587-.492-.507-.676-.516l-.577-.01c-.2 0-.526.075-.802.376-.275.301-1.052 1.028-1.052 2.508 0 1.48 1.077 2.91 1.228 3.111.15.201 2.119 3.235 5.134 4.538.718.31 1.278.496 1.716.635.72.229 1.376.197 1.895.119.578-.087 1.776-.726 2.027-1.428.25-.702.25-1.304.175-1.428-.075-.126-.275-.201-.576-.351z" />
      </svg>
      <style>{`
        @keyframes waPulse {
          0%,100%{ box-shadow:0 4px 24px rgba(37,211,102,0.45); }
          50%{ box-shadow:0 4px 36px rgba(37,211,102,0.75); }
        }
      `}</style>
    </a>
  );
}
